<template>
  <section class="def-lang-select">
    <DefSelectWrapper>
      <template v-if="currentLang" #header>{{ currentLang.name }}</template>
      <a v-for="item in languages" :key="item.link" :href="item.link" class="def-lang-select__item">
        {{ item.name }}
      </a>
    </DefSelectWrapper>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';

export default {
  name: 'DefLangSelect',
  components: { DefSelectWrapper },
  computed: {
    ...mapState({
      languages: ({ results }) => results?.siteLanguages?.items,
    }),
    currentLang() {
      return Object.values(this.languages).find((el) => el.current);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-lang-select {
  text-transform: uppercase;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  min-width: 45px;
  &__item {
    padding: 8px;
    color: var(--color-main);
    transition: 0.2s linear background-color;
    &:hover {
      background-color: var(--color-link-hover);
    }
  }
  :deep(.def-select-wrapper__front) {
    justify-content: center;
    background-color: transparent;
    min-height: 40px;
    border: unset;
    transition: 0.2s linear color;
    padding: 0 22px 0 0;
    &:hover {
      color: var(--color-link-hover);
    }
  }
  :deep(.def-select-wrapper__close) {
    right: 0;
    fill: currentColor;
  }
  :deep(.def-select-wrapper__drop) {
    top: 100%;
  }
}
</style>
